import { httpsCallable } from "firebase/functions";
import { getFirebaseFunctions } from "../firebase";
import { type Factoring } from "./factoringModel";

interface Request {
  id: string;
}

interface Response {
  success: boolean;
  factoring: Factoring;
}

export const swrKey = "admin_getFactoringById";

export const factoringFetcher = async ([_key, id]: [string, string]) => {
  const functions = getFirebaseFunctions();
  const getFactoringFunction = httpsCallable<Request, Response, object>(
    functions,
    swrKey,
  );
  const res = await getFactoringFunction({
    id,
  });
  return res.data.factoring;
};
